import React from "react";
import Success from "./Views/Success";
import { NotificationGroup } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { useSelector } from 'react-redux';


const Notification = (props) => {
  const { notifications } = useSelector(state => state.notificationReducer);

  return (
    <NotificationGroup
      style={{
        right: 10,
        top: 0,
        alignItems: "flex-start",
        flexWrap: "wrap-reverse",
        zIndex: 10004
      }}>
      <Fade>
        {(notifications && notifications.map((notification, index) => {
          return notification.type === 'success' ?
            <Success index={index} message={notification.message} /> : null
        }))}
      </Fade>
    </NotificationGroup>
  )
}

export default Notification;